import { SharedPortalViewService } from './../../shared-portal-view.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-portal-marketing-page',
  templateUrl: './portal-marketing-page.component.html',
  styleUrls: ['./portal-marketing-page.component.css'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.5s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.5s ease-in', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class PortalMarketingPageComponent implements OnInit {
  constructor(
    private route: Router,
    public sharedPortalViewService: SharedPortalViewService,
    private toastr: ToastrService
  ) {}

  async ngOnInit() {}
}
